module.exports = __webpack_public_path__ + "76da0bca1aa8c89983297460277963d7.svg";